import { useState } from "react";
import { Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFileImport, faXmark } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import swal from "sweetalert";

// Kolom mengikuti file referensi Dapodik, tanpa kolom NO.
const dapodikHeader = [["NO", "NAMA LENGKAP", "PANGGILAN", "Masuk Tahun Ajaran", "NIS", "NISN", "P/L", "", "TEMPAT LAHIR", "TANGGAL LAHIR", "AGAMA", "KELAS", "KEWARGANEGARAAN", "ANAK KE", "NIK", "NO AKTE KELAHIRAN", "NO KK", "EMAIL SEKOLAH", "EMAIL BELAJAR ID", "JML. SUADARA KANDUNG", "JML. SUADARA TIRI", "STATUS ANAK", "BAHASA", "ALAMAT di KK", "RT", "RW", "DESA/KEL", "KEC", "KODE POS", "KAB/KOTA", "PROV", "ALAMAT SAAT INI", "KELURAHAN", "KECAMATAN", "KAB/KOTA", "KODE POS", "TINGGAL BERSAMA", "JARAK KE SEKOLAH", "GOL. DARAH", "LINGKAR KEPALA", "BERAT BADAN", "TINGGI BADAN", "PENDIDIKAN SEBELUMNYA", "", "", "", "PINDAHAN/ MUTASI MASUK", "", "STATUS MURID", "DITERIMA DI SEKOLAH INI", "", "AYAH", "", "", "", "", "", "", "", "IBU", "", "", "", "", "", "", "", "PERKEMBANGAN PESERTA DIDIK", "", "", ""], ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "SEKOLAH ASAL", "TGL IJAZAH", "NO IJAZAH", "LAMA BELAJAR", "DARI SEKOLAH", "ALASAN", "", "DI KLS", "TANGGAL", "NAMA", "TGL LAHIR", "PEND. TERAKHIR", "PEKERJAAN", "PENGHASILAN", "NIK", "KONTAK", "KEADAAN", "NAMA", "TGL LAHIR", "PEND. TERAKHIR", "PEKERJAAN", "PENGHASILAN", "NIK", "KONTAK", "KEADAAN", "BEASISWA", "PINDAH SEKOLAH (TANGGAL)", "ALASAN", "SEKOLAH TUJUAN"]];

const downloadWorkbook = async (students, filename, { namaTA, selectedClassName, selectedLevelName }) => {
  const exportFields = {
    0: (student) => student?.nama_siswa || student?.name_student || "",
    2: () => String(namaTA || "").trim() === "2025/2026" ? "" : namaTA || "",
    3: (student) => student?.nis || "",
    4: (student) => String(student?.nisn ?? ""),
    5: (student) => student?.jenis_kelamin || student?.gender || "",
    10: () => selectedClassName === "-" ? "" : selectedClassName,
  };

    const rows = [
      [`REKAP BANK DATA MURID KELAS ${selectedLevelName === "-" ? "" : String(selectedLevelName).replace(/^kelas\s+/i, "")} ${selectedClassName === "-" ? "" : selectedClassName}`.trim()],
      [`TAHUN PELAJARAN ${namaTA || ""}`],
      [],
      dapodikHeader[0].slice(1),
      dapodikHeader[1].slice(1),
      ...students.map((student) => Array.from({ length: 70 }, (_, column) =>
        exportFields[column]?.(student) ?? ""
      )),
    ];
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Data Siswa", { views: [{ state: "frozen", ySplit: 5 }] });
      sheet.columns = Array.from({ length: 70 }, (_, index) => ({ width: index === 0 ? 34 : index === 6 ? 3 : 20 }));
      rows.forEach((row) => sheet.addRow(row));
      sheet.getRow(1).height = 27;
      sheet.getRow(2).height = 24;
      sheet.getRow(4).height = 40;
      sheet.getRow(5).height = 30;
      sheet.mergeCells("C4:C5");
      sheet.mergeCells("AV4:AV5");
      [[42, 45], [46, 47], [49, 50], [51, 58], [59, 66], [67, 70]].forEach(([first, last]) =>
        sheet.mergeCells(4, first, 4, last)
      );
      const border = { style: "thin", color: { argb: "FF000000" } };
      [4, 5].forEach((rowNumber) => {
        for (let column = 1; column <= 70; column += 1) {
          const cell = sheet.getRow(rowNumber).getCell(column);
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD4EAC7" } };
          cell.font = { name: "Arial", size: 10, bold: true, color: { argb: "FF111111" } };
          cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
          cell.border = { top: border, left: border, bottom: border, right: border };
        }
      });
      sheet.getRow(1).font = { name: "Arial", size: 14, bold: true, color: { argb: "FF000000" } };
      sheet.getRow(2).font = { name: "Arial", size: 11, bold: true };
      for (let row = 6; row <= sheet.rowCount; row += 1) {
        sheet.getRow(row).eachCell({ includeEmpty: true }, (cell) => {
          cell.border = { top: border, left: border, bottom: border, right: border };
          cell.alignment = { vertical: "middle" };
        });
      }
      const buffer = await workbook.xlsx.writeBuffer();
      const url = URL.createObjectURL(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      swal("Gagal", "File Excel tidak dapat dibuat. Silakan coba lagi.", "error");
    }
};

export const downloadStudentExcel = (students, context, semester) =>
  downloadWorkbook(students, `data-siswa-semester-${semester || "dipilih"}.xlsx`, context);

export const commitImportedStudents = (rows, { setGetData, setSemesterDataCache, setTablePage, semesterId, currentStudents }) => {
  setGetData((previous) => [...previous, ...rows]);
  setSemesterDataCache((previous) => {
    const key = String(semesterId);
    const current = previous[key] || {};
    return { ...previous, [key]: { ...current, students: [...(current.students || currentStudents), ...rows] } };
  });
  setTablePage(1);
  swal("Berhasil", `${rows.length} siswa ditambahkan sementara ke tabel.`, "success");
};

export default function ImportExcelModal({ onImport, context, ...props }) {
  const [importRows, setImportRows] = useState([]);
  const [importFileName, setImportFileName] = useState("");
  const [importError, setImportError] = useState("");

  const downloadTemplate = () => downloadWorkbook([], "template-import-data-siswa.xlsx", context);

  const readImportFile = async (event) => {
    const file = event.target.files?.[0];
    setImportRows([]);
    setImportError("");
    setImportFileName(file?.name || "");
    if (!file) return;
    if (!/\.xlsx?$/i.test(file.name)) {
      setImportError("Pilih file Excel .xlsx atau .xls.");
      return;
    }
    try {
      const workbook = XLSX.read(await file.arrayBuffer(), { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const table = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "", raw: false });
      const isDapodik = String(table[3]?.[0] || "").trim().toUpperCase() === "NAMA LENGKAP" ||
        String(table[3]?.[1] || "").trim().toUpperCase() === "NAMA LENGKAP";
      const offset = String(table[3]?.[0] || "").trim().toUpperCase() === "NAMA LENGKAP" ? 0 : 1;
      const firstDataRow = isDapodik && String(table[5]?.[offset] || "").trim() === "2" ? 6 : 5;
      const records = isDapodik
        ? table.slice(firstDataRow).filter((row) => row.some((value) => String(value).trim())).map((row) => ({
            nisn: String(row[4 + offset] ?? "").trim(),
            nama_siswa: String(row[offset] ?? "").trim(),
            jenis_kelamin: String(row[5 + offset] ?? "").trim(),
          }))
        : XLSX.utils.sheet_to_json(sheet, { defval: "", raw: false }).map((row) => ({
            nisn: String(row.NISN ?? "").trim(),
            nama_siswa: String(row["Nama Siswa"] ?? "").trim(),
            jenis_kelamin: String(row["Jenis Kelamin"] ?? "").trim(),
          }));
      const rows = records.map((row, index) => ({ ...row, id: `import-${Date.now()}-${index}` }));
      if (!rows.length || rows.some((row) => !row.nama_siswa)) {
        throw new Error("File harus berisi Nama Lengkap untuk setiap siswa.");
      }
      setImportRows(rows);
    } catch (error) {
      setImportError(error?.message || "File Excel tidak dapat dibaca.");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!importRows.length) return;
    onImport(importRows);
    props.onHide();
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog sims-import-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-import-data-siswa"
    >
      <style>{`
       
        .sims-import-description { margin:0 0 18px; color:#68768f; font-size:13px; }
        .sims-template-panel { display:flex; align-items:center; justify-content:space-between; gap:18px; padding:18px; border:1px solid #b8dcff; border-radius:9px; background:#f0f9ff; }
        .sims-template-panel strong { color:#075a91; font-size:14px; }
        .sims-template-panel p { margin:4px 0 0; color:#17324e; font-size:13px; }
        .sims-template-download { flex-shrink:0; display:inline-flex; align-items:center; gap:8px; border:1px solid #1261ff; border-radius:5px; padding:8px 11px; color:#0758e5; background:#fff; font-size:13px; font-weight:700; cursor:pointer; white-space:nowrap; }
        .sims-template-download:hover { background:#eaf2ff; }
        .sims-import-upload { display:block; margin-top:16px; padding:18px; border:1px dashed #a8b9e8; border-radius:12px; background:#f8faff; }
        .sims-import-upload input { display:block; margin-top:9px; width:100%; font-size:13px; }
        .sims-import-message { margin-top:12px; color:#68768f; font-size:13px; }
        .sims-import-error { color:#bf3434; }
        @media (max-width:600px) { .sims-template-panel { align-items:flex-start; flex-direction:column; } }
      `}</style>
      <div className="sims-modal-header">
        <div><h5 id="modal-import-data-siswa" className="sims-modal-title">Import Data Siswa</h5></div>
        <button type="button" className="sims-modal-close" onClick={props.onHide} aria-label="Tutup modal">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="sims-modal-body">
          <div className="sims-template-panel">
            <div>
              <strong>Template Excel Siswa</strong>
            </div>
            <button type="button" className="sims-template-download" onClick={downloadTemplate}>
              <FontAwesomeIcon icon={faDownload} aria-hidden="true" /> Download Template
            </button>
          </div>
          <label className="sims-import-upload">
            <strong>Upload file Excel</strong>
            <input type="file" accept=".xlsx,.xls" onChange={readImportFile} />
          </label>
          {importFileName && <p className="sims-import-message">File: {importFileName}</p>}
          {importRows.length > 0 && <p className="sims-import-message"><strong>{importRows.length} siswa</strong> siap ditambahkan.</p>}
          {importError && <p className="sims-import-message sims-import-error" role="alert">{importError}</p>}
        
        </div>
        <div className="sims-modal-footer">
          <button type="button" className="sims-modal-cancel" onClick={props.onHide}>Batal</button>
          <button type="submit" className="sims-modal-submit" disabled={!importRows.length}>
            <FontAwesomeIcon icon={faFileImport} /> <span>Import Data Siswa</span>
          </button>
        </div>
      </Form>
    </Modal>
  );
}
